var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col" },
          [
            _c(
              _vm.viewType,
              _vm._b(
                {
                  tag: "component",
                  class: _vm.carouselItemTheme,
                  attrs: {
                    items: _vm.items,
                    loading: _vm.isLoading,
                    "num-items": _vm.numItems,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function ({ item }) {
                        return [
                          _c(_vm.componentFile, {
                            tag: "component",
                            attrs: {
                              item: item,
                              "hover-card-enabled": _vm.hoverCardSetting,
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                },
                "component",
                _vm.viewBindings,
                false
              )
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }